import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';

import { userMenu } from '../../Constants/user';

import Home from "./Home";
import Services from "./Services";
import BIM from "./BIM";
import Partners from "./Partners";
import Portfolio from ".//Portfolio";

import './user.scss';

class User extends Component {
    constructor(props) {
        super(props);
        this.state = {
            active: 0,
            language: localStorage.getItem('lang') || 'en',
        }
    }

    makeActive = active => {
        this.setState({ active });
    };

    setLanguage = lang => {
        this.setState({ language: lang });
        localStorage.setItem('lang', lang);
    };

    render() {
        const { language, active } = this.state;
        return (
            <div id={'userPage'}>
                <Switch>
                    <Route
                        exact
                        path="/"
                        render={props => (
                            <Home
                                {...props}
                                lang={language}
                                active={this.makeActive}
                                userMenu={userMenu}
                                setLanguage={this.setLanguage}
                                language={language}
                                activeMenu={active}
                            />
                        )}
                    />
                    <Route
                        path="/services"
                        render={props => (
                            <Services
                                {...props}
                                lang={language}
                                active={this.makeActive}
                                userMenu={userMenu}
                                setLanguage={this.setLanguage}
                                language={language}
                                activeMenu={active}
                            />
                        )}
                    />
                    {/* <Route
                        path="/bim"
                        render={props => (
                            <BIM
                                {...props}
                                lang={language}
                                active={this.makeActive}
                                userMenu={userMenu}
                                setLanguage={this.setLanguage}
                                language={language}
                                activeMenu={active}
                            />
                        )}
                    /> */}
                    <Route
                        path={'/partners'}
                        render={props => (
                            <Partners
                                {...props}
                                lang={language}
                                active={this.makeActive}
                                userMenu={userMenu}
                                setLanguage={this.setLanguage}
                                language={language}
                                activeMenu={active}
                            />
                        )}
                    />
                    <Route
                        path={'/portfolio'}
                        render={props => (
                            <Portfolio
                                {...props}
                                lang={language}
                                active={this.makeActive}
                                userMenu={userMenu}
                                setLanguage={this.setLanguage}
                                language={language}
                                activeMenu={active}
                            />
                        )}
                    />
                </Switch>
            </div>
        )
    }
}

export default User;
